import { Grid, InputLabel, Stack, Typography } from '@hiiretail/react-foundation-ui';
import { TaxRuleResponse } from 'app/services/taxRulesService/taxRulesService.types';
import { VATSummary } from 'common/receipt.types';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { GrossTotalInput } from './GrossTotalInput';
import { VATSummaryRow } from './VATSummaryRow';

interface VATSummaryGroupProps {
  rows: VATSummary[];
  rates: TaxRuleResponse[];
  isLoading: boolean;
  error: {
    data: {
      message: string;
    };
    status: number;
  };
}

export const VATSummaryGroup: FC<VATSummaryGroupProps> = ({ rows, rates, isLoading, error }) => {
  const intl = useIntl();

  return (
    <Stack flexDirection="row" gap={3}>
      <Grid container>
        <Grid item xs={3.5}>
          <Typography textTransform="uppercase">
            {intl.formatMessage({ id: 'receipt.VATSummary' })}
          </Typography>
        </Grid>
        <Grid item xs={6.5} flex={1}>
          <Grid container mb={2}>
            <Grid item xs={5}>
              <InputLabel>{intl.formatMessage({ id: 'receipt.VATSummary.basePrice' })}</InputLabel>
            </Grid>
            <Grid item xs={5}>
              <InputLabel>{intl.formatMessage({ id: 'receipt.VATSummary.VATAmount' })}</InputLabel>
            </Grid>
          </Grid>
          {rows.map((row, index) => {
            const matchingRate = rates.find(
              (rate) => rate.taxableGroupId === row.taxableGroupId,
            )?.vatRate;
            const displayRate = typeof matchingRate === 'number' ? `${matchingRate}%` : null;

            return (
              <VATSummaryRow
                key={row.taxableGroupId}
                index={index}
                row={row}
                rate={displayRate}
                isLoading={isLoading}
                error={error}
              />
            );
          })}
          <Grid container mb={2} minHeight={200} />
        </Grid>
      </Grid>
      <GrossTotalInput />
    </Stack>
  );
};
